import { useEffect, useState } from "react";

const getDimensions = () => {
  if (!window) {
    return {
      width: null,
      height: null,
    };
  }

  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

/**
 * Custom hook for tracking window dimensions.
 *
 * This hook provides real-time window dimensions and automatically updates when the window is resized.
 * It returns the current width and height of the browser window.
 *
 * @returns Object containing current window dimensions
 * @returns width - Current window width in pixels, or null if window is not available
 * @returns height - Current window height in pixels, or null if window is not available
 */
const useDimensions = () => {
  const [dimensions, setDimensions] = useState<{
    width: number | null;
    height: number | null;
  }>(getDimensions());

  useEffect(() => {
    const onResize = () => {
      setDimensions(getDimensions());
    };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return dimensions;
};

export default useDimensions;
